const fontFamily = {
  regularAdnocFontFamily: "ADNOC Sans",
  lightAdnocFontFamily: "ADNOC Sans",
  boldAdnocFontFamily: "ADNOC Sans",
  mediumAdnocFontFamily: "ADNOC Sans",
  xBoldAdnocFontFamily: "ADNOC Sans",
};

export default fontFamily;
